// Load optional theme components when their markup exists, including AJAX results.
// SOLID's own animation, gallery, navigation and cart scripts stay eager.
const config = document.querySelector('[data-solid-component-modules]');
if (config) {
  const pending = new Map(JSON.parse(config.textContent).map(entry => [entry.selector, entry.url]));
  const scan = root => {
    if (!(root instanceof Element) && root !== document) return;
    for (const [selector, url] of pending) {
      if (root.matches?.(selector) || root.querySelector(selector)) {
        pending.delete(selector);
        import(url).catch(error => console.error('Theme component could not load:', url, error));
      }
    }
  };
  scan(document);
  if (pending.size) {
    const observer = new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) scan(node);
      if (!pending.size) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}
